<template>
  <section
    v-if="homeData && homeData.post && homeData.post.length"
    id="homeWeblog"
  >
    <div class="container mt-4">
      <div class="text-center">
        <h2 class="font-w-700 fontsize-heavy mt-3 text-color-theme-dark">
          نظرات مشتریان خاص ثریا مارکت
        </h2>
        <p class="font-w-400 font-s-14 text-color-theme-dark">
          نظرات مصرف کنندهای محصولات ما
        </p>
        <router-link
          to="/weblog-list"
          class="text-color-white fontsize-mini bg-color-theme2 border-r-30 py-2 px-3 mb-1"
        >
          مشاهده همه
        </router-link>
      </div>
      <div
        class="custom-container swiper-weblog-container position-relative mt-5"
      >
        <div class="swiper-weblog">
          <div class="swiper-container">
            <div class="swiper-wrapper">
              <WeblogCard
                v-for="(blog, index) in homeData.post"
                :blog="blog"
                class="swiper-slide"
                :key="index"
              />
            </div>
          </div>
        </div>
        <div class="next-btn-holder d-none d-xl-block">
          <RightChevIcon />
        </div>
        <div class="prev-btn-holder d-none d-xl-block">
          <RightChevIcon />
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import WeblogCard from "@/parts/Front/components/weblog/WeblogCard.vue";
import RightChevIcon from "@/parts/Front/components/Icon/RightChevIcon.vue";
import Swiper from "swiper/swiper-bundle.min.js";

let breakpoints = {
  300: {
    slidesPerView: 1,
    spaceBetween: 10,
  },
  500: {
    slidesPerView: 2,
    spaceBetween: 15,
  },
  992: {
    slidesPerView: 3,
    spaceBetween: 20,
  },
  1200: {
    slidesPerView: 3,
    spaceBetween: 20,
  },
};
export default {
  components: { WeblogCard, RightChevIcon },
  name: "Weblogs",
  data() {
    return {};
  },
  watch: {
    homeData() {
      this.initWeblogSwiper(true);
    },
  },
  mounted() {
    this.initWeblogSwiper();
  },
  computed: {
    homeData() {
      return this.$store.getters["front/getHomeData"];
    },
    status() {
      return this.$store.getters["front/getHomeDataStatus"];
    },
  },
  methods: {
    initWeblogSwiper(kill = false) {
      this.initSwiper("weblog-swiper", kill, () => {
        try {
          if (this.slider) {
            this.slider.destroy();
          }
        } catch (e) {}
        this.slider = new Swiper(".swiper-weblog-container .swiper-container", {
          speed: 1000,
          loop: false,
          autoplay: {
            delay: 7000,
            disableOnInteraction: false,
          },
          navigation: {
            nextEl: ".swiper-weblog-container .next-btn-holder",
            prevEl: ".swiper-weblog-container .prev-btn-holder",
          },
          breakpoints,
        });
      });
    },
  },
};
</script>

<style scoped>
#homeWeblog {
}
#homeWeblog .swiper-weblog-container .next-btn-holder {
  top: 50%;
  left: 101%;
  position: absolute;
  width: fit-content;
  padding: 12px;
  border-radius: 42% 58% 18% 82% / 64% 42% 58% 36%;
  background-color: var(--color-theme3);
  transform: translateY(-50%);
}
#homeWeblog .swiper-weblog-container .prev-btn-holder {
  top: 50%;
  right: 101%;
  position: absolute;
  width: fit-content;
  padding: 12px;
  border-radius: 42% 58% 18% 82% / 64% 42% 58% 36%;
  background-color: var(--color-theme3);
  transform: rotateY(180deg) translateY(-50%);
}
</style>
